import React, { Component, Fragment } from 'react';
import './Map.css';
import { when } from 'mobx';
import { Map as MyMap } from '../../../classes';
import { observer, inject } from 'mobx-react';

import isFunction from 'lodash/isFunction';
import isArray from 'lodash/isArray';
import pick from 'lodash/pick';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';

import placeholder from './placeholder.2';
import LocationAutocomplete from './LocationAutocomplete';
import MapMenu from '../MapMenu';
import MapRadiusEdit from '../MapMenu/MapRadiusEdit';
import MapSavePOI from '../MapMenu/MapSavePOI';
import { renderToString } from 'react-dom/server';
import MarkerInfoBubble from './MarkerInfoBubble';
import MapGeofence from '../MapGeofence';
import MapGeofenceType from '../MapGeofence/MapGeofenceType';
import {AreaIcon} from '../../../common/icons';
import InfoBubble from '../../../components/App/ClientListWithMap/InfoBubble';
import { utils } from '../../../helpers';

@inject('scriptsLoaderStore', 'translationsStore', 'commonStore', 'poiStore', 'mapStore')
@observer
export default class Map extends Component {
  constructor(props) {
    super(props);

    this.defaultRadius = 12000;
    this.minRadius = 200;
    this.maxRadius = 700000;
    this.stepRadius = 1000;
    this.stepRadiusButton = 100;

    this.state = {
      mapId: `map_${new Date().getTime()}`,
      visibleMenu: true,
      searching: false,
      visibleSavePOI: true,
      searchArea: { radius: this.defaultRadius },
      geofenceArea:  this.props.geofenceOptions ? this.props.geofenceOptions : { radius: this.defaultRadius },
	    visibleMenuGeofence: true,
      geofencing: false,
      geofenceType: this.props.geofenceType ? this.props.geofenceType : '',
	    visibleMapGeofenceType: true,
	    visibleMapGeofenceCircle: (this.props.geofenceType ? this.props.geofenceType : '') === 'CIRCLE' ? true : false,
      visibleMapGeofenceSquare: (this.props.geofenceType ? this.props.geofenceType : '') === 'SQUARE' ? true : false,
      visibleMapGeofenceGeolocation: (this.props.geofenceType ? this.props.geofenceType : '') === 'GEOLOCATION' ? true : false,
	    visibleMapGeofenceCustomPolygon: (this.props.geofenceType ? this.props.geofenceType : '') === 'CUSTOM' ? true : false
    };
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.resize);

    when(
      () => this.props.scriptsLoaderStore.mapsjsMapeventsStatus,
      () => {
        if (this.props.scriptsLoaderStore.mapsjsMapeventsStatus === 'loaded' && document.getElementById(this.state.mapId)) {
          const map = new MyMap(this.state.mapId, {
            zoom: this.props.zoom,
            onTap: this.onTap,
            onPointerenter: this.onPointerenter,
            onPointerleave: this.onPointerleave,
            onMapviewchange: this.onMapviewchange,
            placeholder,
            onMapTap: this.onMapTap,
            onMapDrag: this.onMapDrag
          });
          typeof this.props.onMapLoaded === 'function' && this.props.onMapLoaded(map);

          this.setState({ map }, () => {
            if (this.props.polyline) {
              this.state.map.addPolyline(this.props.polyline);
            }
            this.state.map.removeAllMarkers();
            const filteredMarkers = (this.props.markers || []).filter(this.props.markersFilter || (() => true));
            if (filteredMarkers[0] && !isArray(filteredMarkers[0])) {
              this.state.map.addMarkers(filteredMarkers.map(this.props.markersMapper)).showAllMarkers();
            }
            const filteredNoticeMarkers = (this.props.noticeMarkers || []).filter(this.props.markersFilter || (() => true));
            if (filteredNoticeMarkers[0] && !isArray(filteredNoticeMarkers[0])) {
              this.state.map.addMarkers(filteredNoticeMarkers.map(this.props.markersMapper)).showAllMarkers();
              if (filteredNoticeMarkers[0].geofenceOptions && filteredNoticeMarkers[0].geofenceOptions.geofenceType) {
                this.setState({ geofenceType: filteredNoticeMarkers[0].geofenceOptions.geofenceType, geofenceArea: filteredNoticeMarkers[0].geofenceOptions }, function() {
                  this.renderGeofenceArea(this.props.withGeofence ? true : false);
                  //this.state.map.setViewBoundAll();
                });
              } else {
                this.eraseGeofenceArea();
              }
            }
            if (this.props.zoom) {
              this.state.map.setZoom(this.props.zoom);
            }

            if (this.props.geofenceType || this.props.geofenceOptions) {
              this.setState({ type: this.props.geofenceType, geofenceArea: this.props.geofenceOptions }, function() {
                if (this.props.geofenceOptions) {
                  this.renderGeofenceArea(this.props.withGeofence ? true : false);
                }
              });
            }
          });
        }
      }
    );
  };

  componentDidUpdate = async (prevProps, prevStates) => {
    const { translationsStore } = this.props;

    if (this.props.polyline !== prevProps.polyline && this.state.map) {
      this.state.map.addPolyline(this.props.polyline);
    }
    if ((this.props.markers !== prevProps.markers && this.props.markers && this.props.markers.length > 0) || this.props.eta !== prevProps.eta) {
      //static access pattern for better performance
      const prevMarkersObj = {};
      for (let i = 0, len = prevProps.markers.length; i < len; i++) {
        prevMarkersObj[prevProps.markers[i].id] = prevProps.markers[i];
      }

      let somethingChanged = false;

      const markerFilterFn = isFunction(this.props.markersFilter) ? this.props.markersFilter : () => true;
      const prevMarkers = prevProps.markers ? prevProps.markers.filter(markerFilterFn) : false;
      if (prevMarkers) {
        for (let i = 0, len = this.props.markers.length; i < len; i++) {
          if (markerFilterFn(this.props.markers[i])) {
            const marker = this.props.markers[i];

            const prevMarker = prevMarkersObj[marker.id];
            if (prevMarker) {
              //let's see what changed in the marker
              if (marker.hidden === true && !prevMarker.hidden) {
                somethingChanged = true;
                this.state.map.getMarkerById(marker.id).setVisibility(false);
              } else if (marker.hidden === false && prevMarker.hidden === true) {
                somethingChanged = true;
                this.state.map.getMarkerById(marker.id).setVisibility(true);
              }

              const prevLat = isFunction(this.props.getLat) ? this.props.getLat(prevMarker) : prevMarker.lat,
                prevLng = isFunction(this.props.getLng) ? this.props.getLng(prevMarker) : prevMarker.lng,
                lat = isFunction(this.props.getLat) ? this.props.getLat(marker) : marker.lat,
                lng = isFunction(this.props.getLng) ? this.props.getLng(marker) : marker.lng;

              if (prevLat !== lat && (!!prevLat || !!lat)) {
                somethingChanged = true;
                this.state.map.updateMarkerPosition(marker.id, lat, lng);
              } else if (prevLng !== lng && (!!prevLng || !!lng)) {
                somethingChanged = true;
                this.state.map.updateMarkerPosition(marker.id, lat, lng);
              }

              const hMarker =  this.state.map.getMarkerById(marker.id);
              if(!hMarker) {
                continue;
              }
              const car = hMarker.getData();
              let address = undefined;
              if (hMarker.bubble.getState() === 'open') {
                const addressMeta = (lat && lng) ? await this.state.map.getAddressFromReverseGeocode({ lat, lng }) : false;
                if (addressMeta && addressMeta.hasOwnProperty('Label')) {
                  address = addressMeta.label;
                }
              }
              if (this.props.eta && this.props.eta.carId === car.id) {
                let html = renderToString(<InfoBubble translationsStore={translationsStore} car={car} address={address} eta={this.props.eta} />);
                const { getRenderedToReplace } = utils;
                const replacement = getRenderedToReplace(html);
                html = html.replace(/data-replace-render="[^"]+"/g, `onclick="window.${replacement.fn}(event, ${replacement.args.join(', ')})"`);
                this.state.map.setBubbleContent(hMarker.bubble, html).addBubbleClass(hMarker.bubble, 'withETA');
              } else {
                let html = renderToString(<InfoBubble translationsStore={translationsStore} car={car} address={address} />);
                const { getRenderedToReplace } = utils;
                const replacement = getRenderedToReplace(html);
                html = html.replace(/data-replace-render="[^"]+"/g, `onclick="window.${replacement.fn}(event, ${replacement.args.join(', ')})"`);
                this.state.map.setBubbleContent(hMarker.bubble, html).removeBubbleClass(hMarker.bubble, 'withETA');
              }
            } else {
              //the marker is new
              somethingChanged = true;
              this.state.map.addMarker(this.props.markersMapper(marker));
            }
          }
        }

        //static access pattern for better performance
        const markersObj = {};
        for (let i = 0, len = this.props.markers.length; i < len; i++) {
          markersObj[this.props.markers[i].id] = this.props.markers[i];
        }
        for (let i = 0, len = prevMarkers.length; i < len; i++) {
          if (markerFilterFn(prevMarkers[i])) {
            const prevMarker = prevMarkers[i];
            const marker = markersObj[prevMarker.id];
            if (!marker) {
              somethingChanged = true;
              this.state.map.removeMarker(prevMarkers[i]);
            }
          }
        }
      }
      if (somethingChanged) {
        this.state.map.showVisibleMarkers(this.props.setViewBounds);
      }
    }

    //markers from notice
    if (this.props.noticeMarkers !== prevProps.noticeMarkers && this.props.noticeMarkers && this.props.noticeMarkers.length > 0) {
      //static access pattern for better performance
      if (prevProps.noticeMarkers) {
        for (let i = 0, len = prevProps.noticeMarkers.length; i < len; i++) {
          this.state.map.removeMarker(prevProps.noticeMarkers[i]);
        }
      }

	    for (let i = 0, len = this.props.noticeMarkers.length; i < len; i++) {
        const marker = this.props.noticeMarkers[i];
        this.state.map.addMarker(this.props.markersMapper(marker)).showAllMarkers();
        if (marker.geofenceOptions && marker.geofenceOptions.geofenceType) {
          this.setState({ geofenceType: marker.geofenceOptions.geofenceType, geofenceArea: marker.geofenceOptions }, function() {
            this.renderGeofenceArea(this.props.withGeofence ? true : false);
          });
        } else {
          this.eraseGeofenceArea();
        }
      }
    }

    if (this.props.zoom) {
      this.state.map.setZoom(this.props.zoom);
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resize);
  };

  resize = () => {
    this.state.map.resize();
    if (this.props.polyline) {
      this.state.map.addPolyline(this.props.polyline);
    }

    if (this.props.withLocationSearch && this.props.mapStore.areaSearching) {
      this.drawCircle();
    }
  };

  getMap() {
    return this.state.map;
  }

  whenMapIsReady() {
    return new Promise((resolve, reject) => {
      let counter = 0;
      clearInterval(this.mapCheckInterval);
      this.mapCheckInterval = setInterval(() => {
        if (this.getMap()) {
          clearInterval(this.mapCheckInterval);
          resolve(this.getMap());
        } else {
          if (counter > 500) {
            clearInterval(this.mapCheckInterval);
            reject('error instantiating map');
          }
          counter++;
        }
      }, 1);
    });
  }

  onTap = (event, map) => {
    const hMarker = event.target;
    let goon = true;
    if (isFunction(this.props.onTap)) {
      goon = this.props.onTap({ data: hMarker.getData(), event, map });
    }
    if (goon !== false) {
      this._showBubble(hMarker);
    }
    event.stopPropagation();
  };

  onPointerenter = hMarker => {
    let goon = true;
    if (isFunction(this.props.onPointerenter)) {
      goon = this.props.onPointerenter(hMarker.getData());
    }
    if (goon !== false) {
      this._highlightMarker(hMarker);
    }
  };

  onPointerleave = hMarker => {
    let goon = true;
    if (isFunction(this.props.onPointerleave)) {
      goon = this.props.onPointerleave(hMarker.getData());
    }
    if (goon !== false) {
      this._highlightMarker(hMarker, false);
    }
  };

  showBubble(marker) {
    this._showBubble(this.getHMarker(marker));
  }

  _showBubble = hMarker => {
    const {lng, lat} = hMarker.getData();
    const topLatitude = this.state.map.currentViewBounds.getTop(); // H.geo.Latitude
    const bottomLatitude = this.state.map.currentViewBounds.getBottom(); // H.geo.Latitude
    const viewTop = new window.H.geo.Point(topLatitude, lng);
    const viewBottom = new window.H.geo.Point(bottomLatitude, lng);
    const viewDistance = viewTop.distance(viewBottom);
    const topDistance = viewTop.distance(new window.H.geo.Point(lat, lng));
    const topPercentage = (topDistance * 100) / viewDistance;

    if (topPercentage < 40) {
      this.state.map.addBubbleClass(hMarker.bubble, 'H_ib_bottom');
    } else {
      this.state.map.removeBubbleClass(hMarker.bubble, 'H_ib_bottom');
    }

    this.state.map.closeBubbles().showBubbleFor(hMarker);
    this.props.mapStore.setOpenedMarker(hMarker);
  };

  center(marker, zoom) {
    this.state.map.centerMarker(this.getHMarker(marker), zoom);
  }

  highlightMarker(marker, highlight = true) {
    this._highlightMarker(this.getHMarker(marker), highlight);
  }

  _highlightMarker = (hMarker, highlight = true) => {
    if (highlight) {
      this.state.map
        .setZIndex(hMarker, 1000)
        .showMarkerIfHidden(hMarker)
        .then(map => {
          map.highlight(hMarker);
        });
    } else {
      this.state.map.setZIndex(hMarker, 0).highlight(hMarker, false);
    }
  };

  getHMarker = marker => {
    const field = this.props.markerId || 'id';
    const value = marker[field];
    return this.state.map.getMarkerByDataField({ field, value });
  };

  /**
   * return the short side of the viewport in pixel
   */
  getShortSide = () => this.state.map.getShortSide();

  getShortSideInMeter = () => this.state.map.getShortSideInMeter();

  metersToPx = meters => (meters * this.getShortSide()) / this.getShortSideInMeter();

  getRadiusByViewPort = () => {
    if (this.getShortSideInMeter() <= this.maxRadius * 2) {
      return this.getShortSideInMeter() / 2;
    } else {
      return this.maxRadius;
    }
  };

  /**
   * by default draw a circle inscribed in the viewport
   */
  drawCircle = (
    { lat = this.state.map.getCenter().lat, lng = this.state.map.getCenter().lng, radius = this.getRadiusByViewPort() } = {
      lat: this.state.map.getCenter().lat,
      lng: this.state.map.getCenter().lng,
      radius: this.getRadiusByViewPort()
    }
  ) => {
    const searchArea = document.getElementById(`searchArea_${this.state.mapId}`);
    searchArea.style.height = `${this.metersToPx(radius * 2)}px`;
    searchArea.style.width = `${this.metersToPx(radius * 2)}px`;
    searchArea.style.display = 'flex';
    this.setState({
      radius,
      searchArea: {
        lat,
        lng,
        radius
      }
    });
  };

  eraseSearchArea = () => {
    const searchArea = document.getElementById(`searchArea_${this.state.mapId}`);
    searchArea.style.height = `0px`;
    searchArea.style.width = `0px`;
    searchArea.style.display = 'none';
  };

  drawCircleDebounced = debounce((...p) => this.drawCircle(...p),250);
  drawCircleThrottled = throttle((...p) => this.drawCircle(...p),250);

  onMapviewchange = target => {
    const { markers = [] } = this.props;
    markers.map(marker => {
      if (!marker.lastPositionPoint) {
        return;
      }
      const [lng, lat] = marker.lastPositionPoint.coordinates;
      const topLatitude = this.state.map.currentViewBounds.getTop(); // H.geo.Latitude
      const bottomLatitude = this.state.map.currentViewBounds.getBottom(); // H.geo.Latitude
      const viewTop = new window.H.geo.Point(topLatitude, lng);
      const viewBottom = new window.H.geo.Point(bottomLatitude, lng);
      const viewDistance = viewTop.distance(viewBottom);
      const topDistance = viewTop.distance(new window.H.geo.Point(lat, lng));
      const topPercentage = (topDistance * 100) / viewDistance;

      const hMarker = this.state.map.getMarkerById(marker.id);
      if (hMarker.bubble.getState() === 'open' && topPercentage < 40) {
        this.state.map.addBubbleClass(hMarker.bubble, 'H_ib_bottom');
      } else {
        this.state.map.removeBubbleClass(hMarker.bubble, 'H_ib_bottom');
      }
    });
    if (this.props.withLocationSearch && this.props.mapStore.areaSearching) {
      if (!this.adaptingZoom) {
        // this.drawCircle();
        this.drawCircleThrottled();
        // this.drawCircleDebounced();
      }
    }
  };

  onMapTap = () => {
    this.hidePlacesMarkers();
    this.props.mapStore.clearOpenedMarker();
  };

  onMapDrag = () => {
    this.hidePlacesMarkers();
    this.onMapDragDebounced();
  };

  onMapDragDebounced = debounce(() => {
    if (isFunction(this.props.onMapDragDebounced)) {
      this.props.onMapDragDebounced();
    }
  }, 500);

  onRadiusChange = (radius = this.getShortSideInMeter() / 2) => {
    const { lat, lng } = this.state.map.getCenter();
    this.onSelectLocation(lat, lng, radius);
    // this.drawCircle();
    this.drawCircleThrottled();
    // this.drawCircleDebounced();
  };

  onRadiusApply = () => {
    const { searchArea, map } = this.state;
    const { lat, lng, radius } = searchArea;

    this.props.onSearchOnMap({
      lat,
      lng,
      radius,
      contains: (lng, lat) => {
        const distance = new window.H.geo.Point(map.getCenter().lat, map.getCenter().lng).distance(new window.H.geo.Point(lat, lng));
        return distance - radius <= 0;
      },
      distance: (lng, lat) => {
        return new window.H.geo.Point(map.getCenter().lat, map.getCenter().lng).distance(new window.H.geo.Point(lat, lng));
      }
    });
  };

  cancelSearch = () => {
    this.eraseSearchArea();
    this.props.mapStore.setAreaSearching(false);
    if (isFunction(this.props.onCancelSearch)) {
      this.props.onCancelSearch();
    }
  };

  setCenter = (lat, lng) => {
    this.state.map.setCenter(lat, lng);
  };

  setZoom = (zoom) => {
    this.state.map.setZoom(zoom);
  };

  /**
   *
   */
  adaptZoom = (radius, zoom = this.state.map.getZoom(), direction) => {
    this.adaptingZoom = true;
    // const step = 0.1;
    const step = 0.25;
    const d1 = radius * 2;
    const m1 = this.getShortSideInMeter();
    if (zoom > 40) {return}
    if (d1 > m1) {
      if (direction !== 'in') {
        this.state.map.setZoom(zoom - step);
        // setTimeout(() => {
        //   this.adaptZoom(radius, zoom - step, 'out');
        // }, 10);
        this.adaptZoomThrottled(radius, zoom - step, 'out');
      } else {
        this.state.map.setZoom(zoom - step);
        this.adaptingZoom = false;
      }
    } else if (d1 === m1) {
      this.adaptingZoom = false;
    } else {
      if (direction !== 'out') {
        this.state.map.setZoom(zoom + step);
        // setTimeout(() => {
        //   this.adaptZoom(radius, zoom + step, 'in');
        // }, 10);
        this.adaptZoomThrottled(radius, zoom + step, 'in');
      } else {
        this.adaptingZoom = false;
      }
    }
  };

  adaptZoomDebounced = debounce((...p) => this.adaptZoom(...p),250);
  adaptZoomThrottled = throttle((...p) => this.adaptZoom(...p),250);

  onSelectLocation = (lat, lng, radius) => {
    this.setCenter(lat, lng);
    // this.adaptZoomThrottled(Math.max(200, radius));
    this.adaptZoom(Math.max(200, radius));
  };

  onAutocompleteSelect = location => {
    const { map } = this.state;
    const { lat, lng, mapView, matchLevel, metaData = {} } = location;
    if (metaData.source === 'places') {
      this.hidePlacesMarkers();
      const id = metaData.key.split(':')[1];
      const { source, address: content } = metaData;
      const title = metaData.label.replace(/(<([^>]+)>)/g, '');
      map.addMarker({
        source,
        id,
        lat,
        lng,
        html: () => renderToString(<MarkerInfoBubble title={title} content={content} />),
        icon: undefined
      });
      // map.setMarkerIcon(id, renderToString(<MarkerOn />));
      const lastMarker = map.getMarkerById(id);
      map.addObject(lastMarker);
      map.showBubbleFor(lastMarker);
    }
    this.onSelectLocation(lat, lng, mapView.radius);
    if (matchLevel === 'houseNumber' || matchLevel === 'street' || matchLevel === 'city' || metaData.source === 'poi' || metaData.source === 'places') {
      this.props.mapStore.setAreaSearching(true);
    } else {
      this.props.mapStore.setAreaSearching(false);
    }
    if (isFunction(this.props.onSelectLocation)) {
      this.props.onSelectLocation(location);
    }
  };

  hidePlacesMarkers = () => {
    const extraBubbles = this.state.map.getBubbleWithMeta({ source: 'places' });
    extraBubbles.map(bubble => this.state.map.removeBubble(bubble));

    const markers = this.state.map.getMarkersWithMeta({ source: 'places' });
    markers.forEach(marker => {
      this.state.map.removeObject(marker);
      this.state.map.removeMarker(marker.getData());
    });
  };

  onGeofenceTypeChange = (type) => {
	  this.setState({
      geofenceType: type,
		  visibleMapGeofenceCircle: (type === 'CIRCLE') ? true : false,
      visibleMapGeofenceSquare: (type === 'SQUARE') ? true : false,
      visibleMapGeofenceGeolocation: (type === 'GEOLOCATION') ? true : false,
      visibleMapGeofenceCustomPolygon: (type === 'CUSTOM') ? true : false
    });
    const geofenceArea = {
      lat: this.state.map.getCenter().lat,
      lng: this.state.map.getCenter().lng,
      radius: this.getRadiusByViewPort()
    };

    if (type === 'CIRCLE') {
      this.setState({ geofenceArea },function() { this.drawGeofenceCircle(true); });
    }
    if (type === 'SQUARE') {
      this.setState({ geofenceArea }, function() { this.drawGeofenceSquare(true); });
    }
  };

  onAutocompleteGeofenceSelect = location => {
    const { lat, lng, label, mapView, shape, matchLevel, shapeLevel } = location;
    const geofenceArea = {
      lat: location.lat,
      lng: location.lng,
      label,
      shapeLevel,
      mapView,
      shape: shape,
      matchLevel
    };

    if (location.hasOwnProperty('metaData')) {
      this.onSelectLocation(lat, lng, mapView.radius);
    }
    if (isFunction(this.props.onSelectLocation)) {
      this.props.onSelectLocation(location);
    }

    this.setState({ geofenceArea },function() { this.drawGeofenceGeolocation(true); });
  };

  drawGeofenceGeolocation = (editable) => {
    const that = this,
      map = that.state.map,
      geofenceArea = that.state.geofenceArea,
      customGroup = new window.H.map.Group({
        volatility: true
      });

    // if (this.state.map.usingApiKey) { // INFO check if can be improved, as shape may be missing from responses using api key
    //   if (editable)
    //     this.onGeofenceCustomApply();
    // } else {
      if (geofenceArea && geofenceArea.shape) {
        const geometry = window.H.util.wkt.toGeometry(geofenceArea.shape);

        if (geometry instanceof window.H.geo.MultiGeometry) {
          var geometryArray = geometry.getGeometries();
          for (var i = 0; i < geometryArray.length; i++) {
            customGroup.addObject(new window.H.map.Polygon(geometryArray[i].getExterior(),
                {style: {fillColor: 'rgba(255, 0, 0, 0.2)', strokeColor: 'rgb(255, 0, 0)', lineWidth: 1}}));
          }
        } else {
          customGroup.addObject(new window.H.map.Polygon(geometry.getExterior(),
              {style: {fillColor: 'rgba(255, 0, 0, 0.2)', strokeColor: 'rgb(255, 0, 0)', lineWidth: 1}}));
        }

        customGroup.draggable = false;

        map.addGeofenceDraggable(customGroup);

        if (editable)
          this.onGeofenceCustomApply();
      }
    // }
  }

  drawGeofenceCircle = (editable) => {
    const that = this;
    const map = that.state.map;
    const geofenceArea = that.state.geofenceArea;
    if (geofenceArea && geofenceArea.lat && geofenceArea.lng && geofenceArea.radius) {
      const circle = new window.H.map.Circle(
        {lat: geofenceArea.lat, lng: geofenceArea.lng},
        geofenceArea.radius,
        {
          style: {fillColor: 'rgba(255, 0, 0, 0.2)', strokeColor: 'rgb(255, 0, 0)', lineWidth: 1}
        }
      );

      if (editable)
        circle.draggable = true;

      map.addGeofenceDraggable(circle);

      if (editable) {
        circle.addEventListener('dragstart', function(evt) {
          var pointer = evt.currentPointer;
              var object = evt.target;
              var screenPositon = map.geoToScreen(object.getCenter());
              var offset = new window.H.math.Point(pointer.viewportX - screenPositon.x, pointer.viewportY - screenPositon.y);

          object.setData({
            offset: offset
          });
          evt.stopPropagation();
        });

        circle.addEventListener('drag', function(evt) {
          var pointer = evt.currentPointer,
              object = evt.target,
              offset = object.getData()['offset'];

          object.setCenter(map.screenToGeo(pointer.viewportX - offset.x, pointer.viewportY - offset.y));
          geofenceArea.lat = object.getCenter().lat;
          geofenceArea.lng = object.getCenter().lng;
          that.setState({geofenceArea }, function() { that.onGeofenceRadiusApply(); });
          evt.stopPropagation();
        });

        that.onGeofenceRadiusApply();
      }
    }
  };

  drawGeofenceSquare = (editable) => {
      const that = this;
      const map = that.state.map;
      const geofenceArea = that.state.geofenceArea;

      if (geofenceArea && geofenceArea.lat && geofenceArea.lng) {
        var boundingBox = this.getBoundingBox(geofenceArea.lat, geofenceArea.lng, geofenceArea.radius / 1000);
        const square = new window.H.map.Rect(
          new window.H.geo.Rect(boundingBox[1], boundingBox[0], boundingBox[3], boundingBox[2]),
          {
            style: {fillColor: 'rgba(255, 0, 0, 0.2)', strokeColor: 'rgb(255, 0, 0)', lineWidth: 1}
          }
        );

        if (editable)
          square.draggable = true;

        map.addGeofenceDraggable(square);

        if (editable) {
          square.addEventListener('dragstart', function(evt) {
            var pointer = evt.currentPointer,
                object = evt.target;

            object.setData({
              startCoord: map.screenToGeo(pointer.viewportX, pointer.viewportY)
            });
            evt.stopPropagation();
          });

          square.addEventListener('drag', function(evt) {
            var pointer = evt.currentPointer,
                object = evt.target,
                startCoord = object.getData()['startCoord'],
                newCoord = map.screenToGeo(pointer.viewportX, pointer.viewportY);

            if (!newCoord.equals(startCoord)) {
              const geometry = object.getGeometry();
              let newTop, newLeft, newBottom, newRight;
              if (typeof geometry.getBounds === 'function') {
                const currentGeoRect = object.getGeometry().getBounds();
                newTop = currentGeoRect.getTop() + newCoord.lat - startCoord.lat;
                newLeft = currentGeoRect.getLeft() + newCoord.lng - startCoord.lng;
                newBottom = currentGeoRect.getBottom() + newCoord.lat - startCoord.lat;
                newRight = currentGeoRect.getRight() + newCoord.lng - startCoord.lng;
              } else {
                const currentGeoRect = geometry.getBoundingBox();
                newTop = currentGeoRect.getTop() + newCoord.lat - startCoord.lat;
                newLeft = currentGeoRect.getLeft() + newCoord.lng - startCoord.lng;
                newBottom = currentGeoRect.getBottom() + newCoord.lat - startCoord.lat;
                newRight = currentGeoRect.getRight() + newCoord.lng - startCoord.lng;
              }
              const newGeoRect = new window.H.geo.Rect(newTop, newLeft, newBottom, newRight);

                if (newTop >= 90 || newBottom <= -90) {
                  return;
                }

              if (typeof geometry.getBounds === 'function') {
                object.setBounds(newGeoRect);
              } else {
                object.setBoundingBox(newGeoRect);
              }
                object.setData({
                  startCoord: newCoord
                });
                geofenceArea.lat = newGeoRect.getCenter().lat;
                geofenceArea.lng = newGeoRect.getCenter().lng;
                that.setState({geofenceArea }, function() { that.onGeofenceRadiusApply(); });
            }
            evt.stopPropagation();
          });

          that.onGeofenceRadiusApply();
        }
      }
  };

  eraseGeofenceArea = () => {
    this.state.map.removeGeofenceDraggable();
  };

  cancelGeofenceArea = () => {
    this.eraseGeofenceArea();
    this.setState({ geofencing: false });
  };

  onGeofenceCustomApply = () => {
    if (isFunction(this.props.onGeofenceDrawing)) {
      const geofenceArea = this.state.geofenceArea;

      this.props.onGeofenceDrawing(this.state.geofenceType, {
        lat: geofenceArea.lat,
        lng: geofenceArea.lng,
        label: geofenceArea.label,
        shape: geofenceArea.shape,
        mapView: geofenceArea.mapView,
        shapeLevel: geofenceArea.shapeLevel,
        matchLevel: geofenceArea.matchlevel
      });
    }
  }

  onGeofenceRadiusApply = () => {
    if (isFunction(this.props.onGeofenceDrawing)) {
      const { lat, lng, radius } = this.state.geofenceArea,
        polygon = [];

      var i = 0, first = [];

      if (this.state.geofenceType === 'CIRCLE') {
        const circle = new window.H.map.Circle(
          {lat: lat, lng: lng},
          radius
        );

        circle.getGeometry().getExterior().eachLatLngAlt(function(lat1,lng1,alt1) {
          i++;
          polygon.push([ lng1, lat1 ]);
          if (i === 1) {
            first = [ lng1, lat1 ];
          }
        });
        polygon.push(first);
      } else if (this.state.geofenceType === 'SQUARE') {
        var boundingBox = this.getBoundingBox(lat, lng, radius / 1000);
        const square = new window.H.map.Rect(
          new window.H.geo.Rect(boundingBox[1], boundingBox[0], boundingBox[3], boundingBox[2]),
        );

        square.getGeometry().getExterior().eachLatLngAlt(function(lat1,lng1,alt1) {
          i++;
          polygon.push([ lng1, lat1 ]);
          if (i === 1) {
            first = [ lng1, lat1 ];
          }
        });
        polygon.push(first);
      }

      this.props.onGeofenceDrawing(this.state.geofenceType, {
        lat,
        lng,
        radius,
        polygon
      });
    }
  };

  onGeofenceRadiusChange = (radius = this.getShortSideInMeter() / 2) => {
    const geofenceArea = this.state.geofenceArea;
    geofenceArea.radius = radius;
    this.onSelectLocation(geofenceArea.lat, geofenceArea.lng, geofenceArea.radius);
    this.setState({ geofenceArea });
    this.renderGeofenceArea(true);
  };

  onGeofenceRecenter = (radius = this.getShortSideInMeter() / 2) => {
    const { lat, lng } = this.state.map.getCenter();
    const geofenceArea = this.state.geofenceArea;
    geofenceArea.lat = lat;
    geofenceArea.lng = lng;
    this.setState({ geofenceArea });
    this.onSelectLocation(lat, lng, geofenceArea.radius);
    this.renderGeofenceArea(true);
  }

  initGeofenceArea = (geofenceType, geofenceArea) => {
    this.setState({ geofenceType: geofenceType, geofenceArea: geofenceArea }, function() {
        this.renderGeofenceArea(true);
    });
  }

  renderGeofenceArea = (editable) => {
    if (this.state.geofenceType === 'CIRCLE') {
      this.drawGeofenceCircle(editable);
    }
    else if (this.state.geofenceType === 'SQUARE') {
      this.drawGeofenceSquare(editable);
    }
    else if (this.state.geofenceType === 'GEOLOCATION') {
      this.drawGeofenceGeolocation(editable);
    }
  }

  getBoundingBox = function (lat, lng, distance) {
    var MIN_LAT, MAX_LAT, MIN_LON, MAX_LON, R, radDist, degLat, degLon, radLat, radLon, minLat, maxLat, minLon, maxLon, deltaLon;
    if (distance < 0) {
      return 'Illegal arguments';
    }
    Number.prototype.degToRad = function () {
      return this * (Math.PI / 180);
    };
    Number.prototype.radToDeg = function () {
      return (180 * this) / Math.PI;
    };
    MIN_LAT = (-90).degToRad();
    MAX_LAT = (90).degToRad();
    MIN_LON = (-180).degToRad();
    MAX_LON = (180).degToRad();
    R = 6378.1;
    radDist = distance / R;
    degLat = lat;
    degLon = lng;
    radLat = degLat.degToRad();
    radLon = degLon.degToRad();
    minLat = radLat - radDist;
    maxLat = radLat + radDist;
    minLon = void 0;
    maxLon = void 0;
    deltaLon = Math.asin(Math.sin(radDist) / Math.cos(radLat));
    if (minLat > MIN_LAT && maxLat < MAX_LAT) {
      minLon = radLon - deltaLon;
      maxLon = radLon + deltaLon;
      if (minLon < MIN_LON) {
        minLon = minLon + 2 * Math.PI;
      }
      if (maxLon > MAX_LON) {
        maxLon = maxLon - 2 * Math.PI;
      }
    }
    else {
      minLat = Math.max(minLat, MIN_LAT);
      maxLat = Math.min(maxLat, MAX_LAT);
      minLon = MIN_LON;
      maxLon = MAX_LON;
    }
    return [
      minLon.radToDeg(),
      minLat.radToDeg(),
      maxLon.radToDeg(),
      maxLat.radToDeg()
    ];
  };

  render() {
    const { translationsStore } = this.props;
    const appointedPOI = pick(this.state.searchArea, ['lat', 'lng', 'radius']) || {};
    return (
      <div className={`${this.props.className} Map`} id={this.state.mapId} style={{ ...this.props.style }}>
        <div className="searchAreaContainer">
          <div className="searchArea" id={`searchArea_${this.state.mapId}`}>
            <div />
          </div>
        </div>
        {this.props.withLocationSearch && (
          <Fragment>
            {this.state.map && <LocationAutocomplete onSelect={this.onAutocompleteSelect} onCancelSearch={this.cancelSearch} center={this.state.map.getCenter()} />}

            <MapMenu
              visible={this.state.visibleMenu}
              collapsed={!this.props.mapStore.areaSearching}
              onToggleCollapse={() => {
                this.props.mapStore.setAreaSearching(!this.props.mapStore.areaSearching);
                if (this.props.mapStore.areaSearching) {
                  this.onRadiusChange();
                } else {
                  this.cancelSearch();
                }
              }}
            >
              <MapRadiusEdit
                style={{ width: 490 }}
                value={this.state.searchArea.radius}
                minValue={this.minRadius}
                maxValue={this.maxRadius}
                step={this.stepRadius}
                onChange={r => {
                  this.onRadiusChange(r);
                }}
                onApply={this.onRadiusApply}
                onCancel={this.cancelSearch}
                applyLabel={translationsStore.translate('mapMenu.radius.labelApply')}
                showApplyButton={true}
              />
              <MapSavePOI visible={this.state.visibleSavePOI} poi={appointedPOI} onSave={this.onSavePOI} />
            </MapMenu>

          </Fragment>
        )}

		{this.props.withGeofence && (
		  <Fragment>
        {this.state.map && <LocationAutocomplete onSelect={this.onAutocompleteSelect} onCancelSearch={this.cancelSearch} center={this.state.map.getCenter()} />}

        <MapGeofence
          visible={this.state.visibleMenuGeofence}
          collapsed={!this.state.geofencing}
          onToggleCollapse={() => {
            this.setState({ geofencing: !this.state.geofencing }, () => {
              if (this.state.geofencing) {

              } else {

              }
            });
          }}
        >
          <MapGeofenceType visible={this.state.visibleMapGeofenceType} onChange={this.onGeofenceTypeChange} type={this.state.geofenceType} />
          <div className={this.state.visibleMapGeofenceGeolocation ? 'VisibleMapGeofence' : 'hidden'}>
            {this.state.map && <LocationAutocomplete onGeofenceSelect={this.onAutocompleteGeofenceSelect} onCancelSearch={this.cancelSearch} center={this.state.map.getCenter()} showExtraIcons={false} showShapeLevelIcons={true} isGeofenceLocation={true} />}
          </div>
          <div className={this.state.visibleMapGeofenceCircle || this.state.visibleMapGeofenceSquare ? 'VisibleMapGeofence' : 'hidden'}>
            <div className="MapGeofenceRecenter" style={{padding: '0 10px'}} onClick={this.onGeofenceRecenter}>
              <AreaIcon width={25} height={25} />
              <div style={{marginTop: 0}}>{translationsStore.translate('mapGeofence.recenter')}</div>
            </div>
            <div>
              <MapRadiusEdit
                style={{ width: 490 }}
                value={this.state.geofenceArea.radius}
                minValue={this.minRadius}
                maxValue={this.maxRadius}
                step={this.stepRadius}
                onChange={r => {
                  this.onGeofenceRadiusChange(r);
                }}
                onApply={this.onGeofenceRadiusApply}
                onCancel={this.cancelGeofenceArea}
                applyLabel={translationsStore.translate('mapGeofence.verifyArea')}
                showApplyButton={false}
                showStepRadiusButton={true}
                stepButton={this.stepRadiusButton}
              />
            </div>
          </div>
          </MapGeofence>
		  </Fragment>
		)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Map/Map.js